import { computed, onMounted, onBeforeUnmount } from 'vue';
import { Form } from 'vee-validate';
import { scrollToTop } from '../../helpers/scrollToTop';
import { useOnSubmit } from '../../hooks/useOnSubmit';
import AddToCartButton from './AddToCartButton.vue';


export default {
  __name: 'ProductForm',
  props: {
    schema: {
        type: Object,
        required: true,
    },
    initialValues: {
        type: Object,
        required: true,
    },
    checkoutlink: { type: String, required: true },
    id: {
        type: Number,
        required: true,
    },
    price: {
        type: String,
        required: true,
    },
    title: {
        type: String,
        required: true,
    },
    variations: {
        type: Array,
        required: false,
    },
    selectedVariation: {
        type: Number,
        required: false,
    },
},
  setup(__props, { expose }) {
  expose();

const props = __props;

let isNavigatingBack = false;

onMounted(() => {
    history.pushState(null, null, document.URL);

    const handlePopState = (event) => {
        if (!isNavigatingBack) {
            const confirmation = window.confirm('Czy na pewno chcesz opuścić tę stronę?');
            if (confirmation) {
                isNavigatingBack = true;
                history.back();
            } else {
                history.pushState(null, null, document.URL);
            }
        }
    };

    window.addEventListener('popstate', handlePopState);

    onBeforeUnmount(() => {
        window.removeEventListener('popstate', handlePopState);
    });
});



const { onSubmit, isSubmitting } = useOnSubmit(
    props.id,
    props.checkoutlink,
    props.selectedVariation,
);

const renderedPrice = computed(() => {
    if (!props.variations.length) return props.price;

    const price = props.variations?.find(
        (variation) => variation.variation_id === props.selectedVariation,
    ).display_price;

    return String(price);
});

const __returned__ = { get isNavigatingBack() { return isNavigatingBack }, set isNavigatingBack(v) { isNavigatingBack = v }, props, onSubmit, isSubmitting, renderedPrice, computed, onMounted, onBeforeUnmount, get Form() { return Form }, get scrollToTop() { return scrollToTop }, get useOnSubmit() { return useOnSubmit }, AddToCartButton }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

}